<template>
  <div class="about-pmgc">
    <navbar/>
    <div class="animated bounceInDown"><img src="../assets/sean-kong-491810-unsplash.jpg" alt="" class="responsive-img" width="100%"></div>
    <div class="header-text text-center center-align">
      <h4 class="center-align white-text animated slideInLeft">About Us</h4>
    </div>

    <div class="about-content row">
      <div class="card-image">
        <h3 class="header center-align">
          Platinum Minds Global Company
        </h3>
      </div>
      <div class="col s12 m8 offset-m2">
        <div class="card-panel grey-text text-darken-3">
          <span>
            <p class="animated fadeIn">
        Platinum Minds Global Company (PMGC) is a team that comprises of graduates, students and lecturers from different tertiary institutions in Nigeria. PMGC is a registered non-governmental organization with the aim of rejuvenating the dwindling interest in the teaching, learning and application of academic's knowledge acquired to real -life situations and increasing the level at which students reason.
          </p>
          </span>
        </div>
      </div>
    </div>
    <!-- Our mission -->
    <div class="ourMission-content row">
      <div class="card-image">
        <h3 class="header center-align">
          Our Mission
        </h3>
      </div>
      <div class="col s12 m8 offset-m2">
        <div class="card-panel grey-text text-darken-3" style="padding: 0.5rem 1.5rem;">
          <div>
            <div class="arrow-right"></div><p class="animated fadeIn">
              To identify talented intellectuals, employing their deft hands into gigantic innovations for the development of the World.
          </p>
          <div class="arrow-right"></div><p class="animated fadeIn">
            Providing a free avenue for educational consultancy.
          </p>
          <div class="arrow-right"></div><p class="animated fadeIn">
            To achieve a contest where graduates can be camped in our upcoming empire; providing them materials with different task to perform, i.e., production of gadget that can solve the problem of manpower in industries, providing solutions to present and future health problems, addressing problem peculiar to economy crisis of any country, solving the problems of fading agriculture in Nigeria and other countries, etc.
          </p>
          <div class="arrow-right"></div><p class="animated fadeIn">
            Solving of problems peculiar to supply and distribution of general goods.
          </p>
          </div>
        </div>
      </div>
    </div>

    <footer-page/>
    <router-view></router-view>
  </div>
</template>

<script>
import Navbar from '@/components/layouts/navbar'
import FooterPage from '@/components/layouts/footer-page'
export default {
  components: {Navbar, FooterPage}
}
</script>

<style>
  div.about-pmgc h4.center-align.white-text.animated.slideInLeft {
    background-color: rgba(0, 0, 0, 0.4);
    position: absolute;
    padding: 1rem;
    top: 50% !important;
    left: 0px;
    right: 0px;
    font-weight: bold;
    text-transform: uppercase;
  }
  div.about-pmgc .card-panel.grey-text.text-darken-3 {
    padding: 0.5rem 2.4rem !important;
  }

  div.about-pmgc .arrow-right {
    width: 0;
    height: 0;
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    border-left: 10px solid #263238;
    position: absolute;
    left: 18.5%;
  }
</style>



// WEBPACK FOOTER //
// src/pmgc/about.vue